import * as React from 'react'

function ActivityLogPages(props) {
  return (
    <svg 
      className="icon" 
      width={20} 
      height={24} 
      viewBox="0 0 20 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      {...props}
    >
      <g transform="scale(0.7) translate(3, 3.4)">
        <rect 
          width="12" 
          height="16" 
          rx="2" 
          transform="matrix(-1 0 0 1 12 8)" 
          fill="currentColor"
        />
        <path 
          fillRule="evenodd" 
          clipRule="evenodd" 
          d="M18 0C19.1046 0 20 0.895431 20 2V14C20 15.1046 19.1046 16 18 16H14V10C14 7.79086 12.2091 6 10 6H8V2C8 0.895431 8.89543 0 10 0H18Z" 
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export default ActivityLogPages
